import React, {useContext, useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spin, Form, notification, Checkbox} from "antd";
import {consignorService, distributionCenterService, roleService} from "../../../services/";
import InputField from "../../input-field";
import SelectField from "../../select-field";
import ModalDeactiveUser from "../../modals/user/deactive-user.js";
import i18n from '../../../i18n';
import {AppContext} from "../../../contexts/app-context";

export default function ModalFormStaffUser({ isShow, setIsShow, onSuccess, userID = null }) {
  const [loading, setLoading] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  const [rolesList, setRolesList] = useState([]);
  const [distributionCentersList, setDistributionCentersList] = useState([]);

  const [fio, setFio] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState(null);
  const [translatedRoleList, setTranslatedRoleList] = useState(null);
  const [distributionCenters, setDistributionCenters] = useState([]);
  const [notifyDistributionCenters, setNotifyDistributionCenters] = useState([]);
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [blocked, setBlocked] = useState(false);
  const [approvePhoneVisible, setApprovePhoneVisible] = useState(false);
  const [showDeactiveUserModal, setShowDeactiveUserModal] = useState(false);

  const bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px' };
  const approveNumberButton = {height: '43px', background: '#2b3f63', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent", fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '500', lineHeight: '20px' };
  const appContext = useContext(AppContext);

  useEffect(() => {
    const translatedList = rolesList.map((role) => {
      return {Id: role.Id, Name: i18n.t(`constants.roles.${role.Id}`)};
    });
    setTranslatedRoleList(translatedList)
  }, [appContext.lang.lang]);

  useEffect(() => {
    //setLoading(true);
    if (isShow) {
      //Получить список ролей
      roleService
        .getRolesForStaffUser()
        .then(response => {
          const translatedRoles = response.map((role) => {
            return {Id: role.Id, Name: i18n.t(`constants.roles.${role.Id}`)};
          });
          setRolesList(response);
          setTranslatedRoleList(translatedRoles)
        })
        .catch(errorMsg => {
          // setErrorMsg(errorMsg);
        });

        distributionCenterService.getCompanies(true)
            .then((response) => {
                const distCentersData = response.map((distCenterInfo) => {
                    return {
                        Id: distCenterInfo.Id,
                        Name: distCenterInfo.Name,
                    }
                });
                setDistributionCentersList(distCentersData);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.getCompanies2'),
                    description: error,
                });
            });
    }
  }, [isShow]);

  useEffect(() => {
      setIsEditing(!!userID);

      if (isShow && userID) {
          setLoading(true);
          consignorService
              .getStaffUserInfo(userID)
              .then((resp) => {
                  setFio(resp.FIO);
                  setPhone(resp.Phone);
                  setEmail(resp.Email);
                  setRole(resp.Role);
                  setDistributionCenters(resp.DistributionCentersIDs.map((value) => {
                      return Number(value);
                  }));
                  setNotifyDistributionCenters(resp.NotifyDistributionCentersIDs.map((value) => {
                      return Number(value);
                  }));
                  setBlocked(resp.Blocked);

                  setLoading(false);
              })
              .catch((err) => {
                  notification.error({
                      message: i18n.t('components.notification.titles.getStaffUserInfo'),
                      description: err,
                  });

                  setLoading(false);
              });
      }
  }, [isShow, userID]);

  const onSubmitFormCreate = e => {
    e.preventDefault();

    setLoading(true);

    consignorService
      .createStaffUser({ fio, phone, email, password, passwordRepeat, role, distributionCenters, notifyDistributionCenters })
      .then(responseData => {
        if (responseData.status === "success") {
          notification.success({
            message: i18n.t('components.notification.titles.createStaffUser'),
            description: responseData.message
          });
          setLoading(false);
          setIsShow(false);
          onSuccess();
        } else if (responseData.status === "error") {
          if (responseData.message) {
            notification.error({
              message: i18n.t('components.notification.titles.createStaffUser'),
              description: responseData.message
            });
          }
          setLoading(false);
          if (responseData.errors) {
            setFieldsErrors(responseData.errors);
          }

          if (responseData.errors && responseData.errors.phone_used) {
            setApprovePhoneVisible(true);
          }
        }
      })
      .catch(errorMsg => {
        notification.error({
          message: i18n.t('components.notification.titles.createStaffUser'),
          description: errorMsg
        });
        setLoading(false);
      });
  };

  const onSubmitFromEdit = () => {
      setLoading(true);

      consignorService
          .editStaffUser({ userID, fio, phone, email, role, distributionCenters, notifyDistributionCenters, blocked })
          .then(responseData => {
              if (responseData.status === "success") {
                  notification.success({
                      message: i18n.t('components.notification.titles.editStaffUser'),
                      description: responseData.message
                  });
                  setLoading(false);
                  setIsShow(false);
                  onSuccess();
              } else if (responseData.status === "error") {
                  if (responseData.message) {
                      notification.error({
                          message: i18n.t('components.notification.titles.editStaffUser'),
                          description: responseData.message
                      });
                  }
                  setLoading(false);
                  if (responseData.errors) {
                      setFieldsErrors(responseData.errors);
                  }
              }
          })
          .catch(errorMsg => {
              notification.error({
                  message: i18n.t('components.notification.titles.createStaffUser'),
                  description: errorMsg
              });
              setLoading(false);
          });
  };

  const getFieldErrors = fieldName => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  const renderFooterButton = () => {
      if (isEditing) {
          return (
              <Button htmlType="submit" key="submit" style={bigButtonStyle} type="primary" onClick={onSubmitFromEdit}>
                {i18n.t('main.buttons.save')}
              </Button>
          );
      }
      return (
          <Button htmlType="submit" key="submit" style={bigButtonStyle} type="primary" onClick={onSubmitFormCreate}>
            {i18n.t('main.buttons.create')}
          </Button>
      );
  };

  return (
    <Modal
      title={i18n.t('modals.modalFormStaffUser.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={renderFooterButton()}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Form>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24} >
              <InputField name="fio" label={i18n.t('modals.modalFormStaffUser.fields.fio.title')} value={fio} setValue={setFio} getFieldErrors={getFieldErrors} />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24} >
              <InputField name="phone" label={i18n.t('modals.modalFormStaffUser.fields.phone.title')} value={phone} setValue={setPhone} getFieldErrors={getFieldErrors} />
            </Col>
          </Row>
          {approvePhoneVisible ? (
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Button
                style={approveNumberButton}
                htmlType="submit"
                type="primary"
                onClick={setShowDeactiveUserModal}
                key="get-codes"
              >
                {i18n.t('modals.modalFormStaffUser.buttons.approveNumberButton')}
              </Button>
              <ModalDeactiveUser isShow={showDeactiveUserModal} onCloseModal={setShowDeactiveUserModal} phone={phone} />
            </Col>
          </Row>) : null}
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24} >
              <InputField name="email" label={i18n.t('modals.modalFormStaffUser.fields.email.title')} value={email} setValue={setEmail} getFieldErrors={getFieldErrors} />
            </Col>
          </Row>
            {!isEditing &&
            <Row gutter={[16, 24]}>
                <Col lg={12} md={24} sm={24} xs={24}>
                    <InputField name="password" label={i18n.t('modals.modalFormStaffUser.fields.password.title')} value={password} setValue={setPassword} getFieldErrors={getFieldErrors} type="password"/>
                </Col>
                <Col lg={12} md={24} sm={24} xs={24}>
                    <InputField
                        name="passwordRepeat"
                        type="password"
                        label={i18n.t('modals.modalFormStaffUser.fields.passwordRepeat.title')}
                        value={passwordRepeat}
                        setValue={setPasswordRepeat}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>}
            <Row gutter={[16, 24]}>
                <Col lg={12} md={24} sm={24} xs={24} >
                    <SelectField
                        title={i18n.t('modals.modalFormStaffUser.fields.role.title')}
                        name="role"
                        selectedValue={role}
                        values={translatedRoleList}
                        onChange={(value) => {
                            setRole(value);
                        }}
                        getErrors={getFieldErrors}
                        placeholder={i18n.t('modals.modalFormStaffUser.fields.role.placeholder')}
                        notFoundText={i18n.t('modals.modalFormStaffUser.fields.role.notFoundText')}
                        style={{ width: "100%" }}
                    />
                </Col>
                <Col span={24} >
                    <SelectField
                        mode="multiple"
                        title={i18n.t('modals.modalFormStaffUser.fields.distributionsCentersIds.title')}
                        name="distributionsCentersIds"
                        selectedValue={distributionCenters}
                        values={distributionCentersList}
                        onChange={(value) => {
                            setDistributionCenters([...value]);
                        }}
                        getErrors={getFieldErrors}
                        placeholder={i18n.t('modals.modalFormStaffUser.fields.distributionsCentersIds.placeholder')}
                        notFoundText={i18n.t('modals.modalFormStaffUser.fields.distributionsCentersIds.notFoundText')}
                        style={{ width: "100%" }}
                    />
                </Col>
                <Col span={24} >
                    <SelectField
                        mode="multiple"
                        title={i18n.t('modals.modalFormStaffUser.fields.notifyDistributionsCentersIds.title')}
                        name="notifyDistributionsCentersIds"
                        selectedValue={notifyDistributionCenters}
                        values={distributionCentersList}
                        onChange={(value) => {
                            setNotifyDistributionCenters([...value]);
                        }}
                        getErrors={getFieldErrors}
                        placeholder={i18n.t('modals.modalFormStaffUser.fields.notifyDistributionsCentersIds.placeholder')}
                        notFoundText={i18n.t('modals.modalFormStaffUser.fields.notifyDistributionsCentersIds.notFoundText')}
                        style={{ width: "100%" }}
                    />
                </Col>
            </Row>
            {isEditing &&
            <Row gutter={[16, 24]}>
                <Checkbox
                    name="blocked"
                    checked={blocked}
                    onChange={(e) => {
                        setBlocked(e.target.checked);
                    }}
                    style={{ paddingTop: "15px" }}
                >
                  {i18n.t('modals.modalFormStaffUser.fields.blocked.title')}
                </Checkbox>
            </Row>}
        </Form>
      </Spin>
    </Modal>
  );
}
